<div id="content" class="page">
  <div class="page__header">
    <custom-app-bar [hasBackButton]="true"></custom-app-bar>
  </div>
  <ng-container
    *ngIf="
      (resetPasswordViewModel.passwordReset$ | async) == false;
      else resetPasswordSuccess
    "
  >
    <div class="page__content">
      <h1 class="header2">{{ "reset_password.title" | translate }}</h1>
      <p class="text">{{ "reset_password.message" | translate }}</p>
      <form
        id="email-form"
        (ngSubmit)="onSubmit()"
        [formGroup]="resetPasswordForm"
      >
        <custom-form-field
          type="email"
          [label]="'reset_password.email_label' | translate"
          controlName="email"
          [formGroup]="resetPasswordForm"
        >
        </custom-form-field>
      </form>
    </div>

    <div class="page__footer">
      <div class="loading" *ngIf="!!(resetPasswordViewModel.loading$ | async)">
        <ep-loading-spinner></ep-loading-spinner>
      </div>
      <custom-button
        expand="full"
        size="large"
        (onClick)="onSubmit()"
        [disabled]="
          !resetPasswordForm.valid ||
          !!(resetPasswordViewModel.loading$ | async)
        "
      >
        {{ "reset_password.send" | translate }}
      </custom-button>
    </div>
  </ng-container>
  <ng-template #resetPasswordSuccess>
    <div class="page__content">
      <h1 class="header2">{{ "reset_password.success_title" | translate }}</h1>
      <p class="text">{{ "reset_password.success_message" | translate }}</p>
    </div>

    <div class="page__footer">
      <custom-button
        expand="full"
        size="large"
        [routerLink]="['/', routeNames.login] | localize"
      >
        {{ "login.button" | translate }}
      </custom-button>
    </div>
  </ng-template>
</div>
